/* eslint-disable no-unused-vars */
import { api } from '@/helpers/api';

export default {
  async getAttendances({ commit, dispatch }, { studentId, payload }) {
    const response = await api.get(`parent/me/students/${studentId}/attendances`, { params: payload });

    const data = response.data.results;
    commit('setAttendances', data);
  },

  clearAttendances({ commit }) {
    commit('clearAttendances');
  },
};
